import {
  GiftCardCreateModel,
  GiftCardJournalItem,
  GiftCardModel,
  GiftCardPaymentStatus,
  GiftCardStatus,
  GiftCardViewModel
} from 'shared/models'
import { adminInstance } from '.'
import { AxiosRequestConfig } from 'axios'

const giftCard = {
  getGiftCardList(
    params: {
      status?: string[]
      page: number
      limit: number
      term?: string
    },
    config?: AxiosRequestConfig
  ) {
    return adminInstance.get<{ list: GiftCardModel[]; total: number; page: number; pageCount: number }>('/giftCards', {
      params,
      paramsSerializer: { indexes: null },
      ...config
    })
  },

  getGiftCard(giftCardId: string, config?: AxiosRequestConfig) {
    return adminInstance.get<GiftCardViewModel>(`/giftCards/${giftCardId}`, config)
  },

  getPaymentLink({ giftCardId }: { giftCardId: number }, config?: AxiosRequestConfig) {
    return adminInstance.get<{ paymentLink: string }>(`/giftCards/${giftCardId}/getPaymentLink`, {
      ...config
    })
  },

  createGiftCard(data: GiftCardCreateModel, config?: AxiosRequestConfig) {
    return adminInstance.post<{ id: number; paymentLink: string }>(`/giftCards`, data, config)
  },

  cancelGiftCard(giftCardId: number, config?: AxiosRequestConfig) {
    return adminInstance.delete<void>(`/giftCards/${giftCardId}`, config)
  },

  changeStaffComment(giftCardId: number, comment: string, config?: AxiosRequestConfig) {
    return adminInstance.patch(`/giftCards/${giftCardId}/editStaffComment`, { comment }, config)
  },

  changeStatus(giftCardId: number, status: GiftCardStatus, config?: AxiosRequestConfig) {
    return adminInstance.patch(`/giftCards/${giftCardId}/editStatus`, { status }, config)
  },

  changePaymentStatus(giftCardId: number, status: GiftCardPaymentStatus, config?: AxiosRequestConfig) {
    return adminInstance.patch(`/giftCards/${giftCardId}/editPaymentStatus`, { status }, config)
  },

  getJournal(giftCardId: number, config?: AxiosRequestConfig) {
    return adminInstance.get<GiftCardJournalItem[]>(`/giftCards/${giftCardId}/journal`, config)
  },

  reedem(
    data: { giftCardId: number; staffComment: string; orderId: string | null; pin: string; force?: boolean },
    config?: AxiosRequestConfig
  ) {
    return adminInstance.post(`/giftCards/${data.giftCardId}/redeem`, data, config)
  }
}

export { giftCard }
